import Vue from 'vue';
import Vuex, {ActionContext} from 'vuex';
import {XHTTPService} from '@/shared/xhttp';
import {DocumentAchat} from "@/models/DocumentAchat";
import {DocumentAchatService} from "@/xhttp/DocumentAchatService";
import store from '@/stores';
import achat from "@/router/achat";
import storeAchat from "@/stores/modules/achat";

Vue.use(Vuex);

class DocumentAchatState {
}

class DocumentAchatStore {

	@XHTTPService(() => DocumentAchat)
	private documentService: DocumentAchatService;

	public state: DocumentAchatState = new DocumentAchatState();

	public mutations = {
	};

	public actions = {
		async delete(context: ActionContext<DocumentAchatState, any>, document: DocumentAchat): Promise<DocumentAchat> {
			try {
				document.achat.removeDocuments(document);
				return await instance.documentService.delete('/{id}', document);
			} catch (e) {
				storeAchat.dispatch('get', document.achat.id);
				throw e;
			}
		}
	};

}
const instance = new DocumentAchatStore();
const storeDocumentAchat = new Vuex.Store(instance);
store.registerModule('document', storeDocumentAchat);
export default storeDocumentAchat;
